


















import Component from 'vue-class-component'
import { required } from 'vuelidate/lib/validators'
import Vue from 'vue'
import InputV2 from '@/components/inputsV2/InputV2.vue'
import InputValidator from '@/components/inputsV2/InputValidator.vue'
@Component({
    components: {
        InputV2,
        InputValidator
    },
    props: {
        milestoneName: {
            type: String,
            required: true
        },
        isEdit: {
            type: Boolean
        }
    }
})
export default class EditAddMilestone extends Vue {
    currentValue: string = ''
    validations () {
        return {
            currentValue: {
                required
            }
        }
    }
    mounted () {
        this.currentValue = this.$props.milestoneName
    }
    creatEditMilestone (eventType: 'createdMilestone' | 'editedMilestone') {
        this.$v.$touch()
        if (this.$v.$anyError) {
            return
        }
        this.$emit(eventType, this.currentValue)
    }
    updateValue (value: string) {
        this.currentValue = value
    }
}
